// extracted by mini-css-extract-plugin
module.exports = {"main":"FooterMenu_main__7HAwT","menuItem__desktop":"FooterMenu_menuItem__desktop__TI_pe","menuItem":"FooterMenu_menuItem__oPS7U"};